export const PlatformEnum = Object.freeze({
  POS: "POS",
  BACK_OFFICE: "BACK_OFFICE",
});
